import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Chart from '../../../components/Chart';
import PieChart from '../../../components/PiePanel';
import FixedPanel from '../../../components/FixedPanel';

const Panel: React.FC<{
  panelType: string;
  panelName: string;
  endpoint: string;
  textColor: string;
  backColor: string;
}> = ({ panelType, panelName, endpoint, textColor, backColor }) => {
  return (
    <Paper
      style={{ backgroundColor: backColor, margin: '1%', height: '350px' }}
      elevation={1}
    >
      <Typography style={{ color: textColor }}>
        <b>{panelType !== 'noPanel' ? panelName : ''}</b>
      </Typography>
      {panelType === 'chartPanel' ? (
        <div>
          <Chart chartName={panelName} endpoint={endpoint} />
        </div>
      ) : panelType === 'piePanel' ? (
        <div>
          <PieChart
            chartName={panelName}
            endpoint={endpoint}
            textColor={textColor}
          />
        </div>
      ) : panelType === 'fixedPanel' ? (
        <div>
          <FixedPanel
            chartName={panelName}
            endpoint={endpoint}
            textColor={textColor}
          />
        </div>
      ) : (
        <div>
          <FixedPanel chartName={panelName} endpoint="" textColor={textColor} />
        </div>
      )}
    </Paper>
  );
};

export default Panel;
